__turbopack_context__.v({
  "active": "CatalogHeader-module__P3k4OW__active",
  "activeSubcategory": "CatalogHeader-module__P3k4OW__activeSubcategory",
  "categoriesContainer": "CatalogHeader-module__P3k4OW__categoriesContainer",
  "categoriesGrid": "CatalogHeader-module__P3k4OW__categoriesGrid",
  "categoryContent": "CatalogHeader-module__P3k4OW__categoryContent",
  "categoryHeader": "CatalogHeader-module__P3k4OW__categoryHeader",
  "categoryList": "CatalogHeader-module__P3k4OW__categoryList",
  "categorySection": "CatalogHeader-module__P3k4OW__categorySection",
  "categoryTitle": "CatalogHeader-module__P3k4OW__categoryTitle",
  "chevronIcon": "CatalogHeader-module__P3k4OW__chevronIcon",
  "emptyColumn": "CatalogHeader-module__P3k4OW__emptyColumn",
  "loadingMessage": "CatalogHeader-module__P3k4OW__loadingMessage",
  "menuContainer": "CatalogHeader-module__P3k4OW__menuContainer",
  "nestedSubcategories": "CatalogHeader-module__P3k4OW__nestedSubcategories",
  "nestedSubcategoryLink": "CatalogHeader-module__P3k4OW__nestedSubcategoryLink",
  "noCategoriesMessage": "CatalogHeader-module__P3k4OW__noCategoriesMessage",
  "rotated": "CatalogHeader-module__P3k4OW__rotated",
  "row": "CatalogHeader-module__P3k4OW__row",
  "sectionTitle": "CatalogHeader-module__P3k4OW__sectionTitle",
  "selectedCategoryHeader": "CatalogHeader-module__P3k4OW__selectedCategoryHeader",
  "selectedTab": "CatalogHeader-module__P3k4OW__selectedTab",
  "subcategoryItem": "CatalogHeader-module__P3k4OW__subcategoryItem",
  "subcategoryLink": "CatalogHeader-module__P3k4OW__subcategoryLink",
  "subcategoryList": "CatalogHeader-module__P3k4OW__subcategoryList",
  "tabButton": "CatalogHeader-module__P3k4OW__tabButton",
  "tabButtons": "CatalogHeader-module__P3k4OW__tabButtons",
  "tabContent": "CatalogHeader-module__P3k4OW__tabContent",
  "tabHeader": "CatalogHeader-module__P3k4OW__tabHeader",
  "tabLayout": "CatalogHeader-module__P3k4OW__tabLayout",
  "tabTitle": "CatalogHeader-module__P3k4OW__tabTitle",
});
